// WithPinMessageButton.jsx
import { useCallback } from 'react';
import PropTypes from 'prop-types';

import trackMixpanel, {
  EventTypes,
  ButtonId,
  getViewId,
} from '../resource/mixpanel.js';

export const WithPinMessageButton = ({
  messageId,
  pinFeedAlias,
  pinMax,
  isPinned,
  pinnedItemIds,
  children,
  submitFeedsPin,
  toggleModal,
}) => {
  const trackUserClick = ({ buttonId }) => {
    trackMixpanel({
      type: EventTypes.USER_CLICKED,
      payload: {
        viewId: getViewId({ pathname: window.location.pathname }),
        buttonId,
      },
    });
  };
  const handleClick = useCallback(() => {
    trackUserClick({
      buttonId: isPinned ? ButtonId.All.ButtonUnpin : ButtonId.All.ButtonPin,
    });
    if (isPinned || pinnedItemIds.length >= pinMax) {
      return toggleModal({
        modalId: 'PinConfirmModal',
        payload: {
          id: messageId,
          pinFeedAlias,
          isUnpin: !!isPinned,
        },
        isOpen: true,
      });
    }
    return submitFeedsPin({ id: messageId, feedAlias: pinFeedAlias });
  }, [
    isPinned,
    pinnedItemIds.length,
    pinMax,
    submitFeedsPin,
    messageId,
    pinFeedAlias,
    toggleModal,
  ]);
  return children({
    isPinned,
    handleClick,
  });
};

WithPinMessageButton.propTypes = {
  messageId: PropTypes.string,
  pinFeedAlias: PropTypes.string,
  pinMax: PropTypes.number,
  isPinned: PropTypes.bool,
  pinnedItemIds: PropTypes.array,
  children: PropTypes.func,
  submitFeedsPin: PropTypes.func,
  toggleModal: PropTypes.func,
};

WithPinMessageButton.defaultProps = {
  messageId: null,
  pinFeedAlias: null,
  pinMax: 1,
  isPinned: false,
  pinnedItemIds: [],
  children: () => null,
  submitFeedsPin: () => null,
  toggleModal: () => null,
};

export default WithPinMessageButton;
